import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import React from 'react'

interface MenuColumnProps {
  header: string
}

export const MenuColumn: React.FC<MenuColumnProps> = ({ header, children }) => {
  return (
    <List
      subheader={
        <Typography
          sx={{
            fontWeight: 700,
            mb: 1,
            textTransform: 'uppercase',
            opacity: 0.8
          }}
        >
          {header}
        </Typography>
      }
      dense
      disablePadding
    >
      {children}
    </List>
  )
}
